import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Polar } from './polar';
export var getRadialOptions = function getRadialOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultOptions = {
    startAngle: -Math.PI / 2,
    endAngle: Math.PI * 3 / 2,
    innerRadius: 0,
    outerRadius: 1
  };
  return Object.assign(Object.assign({}, defaultOptions), options);
};
/**
 * Radial
 */
export var Radial = function Radial(options) {
  var _getRadialOptions = getRadialOptions(options),
    startAngle = _getRadialOptions.startAngle,
    endAngle = _getRadialOptions.endAngle,
    innerRadius = _getRadialOptions.innerRadius,
    outerRadius = _getRadialOptions.outerRadius;
  return [['transpose'], ['translate', 0.5, 0.5], ['reflect'], ['translate', -0.5, -0.5]].concat(_toConsumableArray(Polar({
    startAngle: startAngle,
    endAngle: endAngle,
    innerRadius: innerRadius,
    outerRadius: outerRadius
  })));
};
Radial.props = {};